import type { Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

const AUTH_BACKGROUND_IMAGE = 'url(/images/narralyze-bg.jpeg)';

/** Full-viewport shell for login / register / password flows (matches app theme). */
export function authMarketingShellSx(theme: Theme) {
  return {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative' as const,
    bgcolor: theme.palette.background.default,
    backgroundImage: [
      `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.85)} 0%, ${alpha(
        theme.palette.primary.dark,
        0.92,
      )} 45%, ${alpha('#312e81', 0.9)} 100%)`,
      AUTH_BACKGROUND_IMAGE,
    ].join(', '),
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      backgroundColor: alpha(theme.palette.common.black, 0.4),
      zIndex: 1,
    },
  };
}

export function authFormCardSx(theme: Theme, opts?: { maxWidth?: number }) {
  const maxWidth = opts?.maxWidth ?? 450;
  return {
    p: { xs: 3, sm: 4 },
    width: '100%',
    maxWidth,
    borderRadius: '8px',
    bgcolor: alpha(theme.palette.background.paper, 0.97),
    backdropFilter: 'blur(10px)',
    boxShadow: theme.shadows[16],
    border: `1px solid ${alpha(theme.palette.common.white, 0.32)}`,
  };
}
